import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherA');
    const { pageType } = useProductStore();
    const listA = [
        {
            text1: t('a_text1'),
            text2: t('a_text2'),
            text3: t('a_text3'),
        },
        {
            text1: t('b_text1'),
            text2: t('b_text2'),
            text3: t('b_text3'),
        },
        {
            text1: t('c_text1'),
            text2: t('c_text2'),
            text3: t('c_text3'),
        },
        {
            text1: t('d_text1'),
            text2: t('d_text2'),
            text3: t('d_text3'),
        },
    ];
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726019804404/pc_2X%20power.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726019804404/pc_2X%20power.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726019797121/m_2X%20power.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726121345916/pc_2X_power.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1726121345916/pc_2X_power.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726648264665/m_2X_power_tm.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={`${styles.TheComp} ${pageType === PAGE_TYPE.BASE ? 'black' : 'white'}`}>
            <div className="OtherA-msg">
                <EfSection theme={pageType === PAGE_TYPE.BASE ? 'black' : 'white'} label={t('label')} title={t('title')} desc={t('desc')} />
                <div className="ef-container OtherA-list">
                    <div className="OtherA-list-in">
                        {listA.map((item: any, index: number) => (
                            <div className={`OtherA-item item${index}`} key={index}>
                                <div className="OtherA-item-line1">
                                    <div className="OtherA-item-line1-text1">{item.text1}</div>
                                    <div className="OtherA-item-line1-text2">{item.text2}</div>
                                </div>
                                <div className="OtherA-item-line2">{item.text3}</div>
                            </div>
                        ))}
                    </div>
                </div>
                {pageType === PAGE_TYPE.BASE && (
                    <div className="OtherA-tips-box">
                        <div className="tips1">{t('compared_tips1')}</div>
                        <div className="tips2">{t('compared_tips2')}</div>
                    </div>
                )}
            </div>
            <div className="OtherA-img">
                <EfImg pc={bg.pc} pad={bg.pad} h5={bg.h5} />
            </div>
        </div>
    );
}
